import {Configuration} from '@/Stub/V1';
import {useAuthStore} from '@/Stores/AuthStore';

export const BaseApiConfig: Configuration = new Configuration({
    basePath: import.meta.env.VITE_API_V2_URL,
    accessToken: () => useAuthStore.getState().accessToken as string,
    headers: {
        'Accept': 'application/json'
    }
});
